import React, {useEffect, useState} from 'react';
import { useGlobal } from 'reactn';
import { formatDate } from '../../../helpers';
import api from '../../../api';
import { Table } from 'antd';

const CustomerSvcTable = ({ title1, title2, title3, title4, title5 }) => {
  const [svcOrder, setServiceOrder] = useState(null);
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];
 

  const getSvcOrder = async () => {
    const accntNo = selectedServiceAccount.data.ACCOUNT;
    try {
      const order = await api.getServiceOrder(accntNo);
      setServiceOrder(order);
    }
    catch(error) {
      console.log(error);
    }
  }

  
  useEffect(() => {
    getSvcOrder();
 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (!svcOrder) return <p>Loading service order...</p>

  const columns = [
    {
      title: 'Account',
      dataIndex: 'account',
    },
    {
      title: 'Service Request Status',
      dataIndex: 'workOrderStatus',
    },
    {
      title: 'Service Request Date',
      dataIndex: 'workOrderDate',
    },
    {
      title: 'Service Request Number',
      dataIndex: 'workOrderNumber',
    },
    {
      title: 'App Date',
      dataIndex: 'appDate',
    },
    {
      title: 'App Time',
      dataIndex: 'appTime',
    },
    {
      title: 'Job Code',
      dataIndex: 'jobCode',
    },
  ];

  const svcData = svcOrder?.data
    ?.map((p, idx) => {
      return {
        key: `${idx + 1}`,
        account: p.ACCOUNT,
        appDate: formatDate(p.APPDATE),
        appTime: p.APPTIME,
        workOrderDate: formatDate(p.WODATE),
        jobCode: p.JOBCODE,
        workOrderNumber: p.WONO,
        workOrderStatus: p.WOSTATUS
      };
    });

 
  const onChange = (pagination, filters, sorter, extra) => {

  };

  return (
    <Table
      className="overflow-x-scroll"
      pagination={false}
      columns={columns}
      dataSource={svcData}
      onChange={onChange}
    />
  );
};

export default CustomerSvcTable;
